import React from "react";
import * as Sentry from "@sentry/react";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";

function SentryTestPage() {
  const handleSendMessage = () => {
    Sentry.captureMessage("This is a test message from the React application.");
    alert("Sentry message sent!");
  };

  return (
    <Container>
      <Typography variant="h4" gutterBottom>
        Sentry Test Page
      </Typography>
      <Typography paragraph>
        Click the button below to send a test message to Sentry.
      </Typography>
      <Button variant="contained" color="primary" onClick={handleSendMessage}>
        Send Sentry Message
      </Button>
    </Container>
  );
}

export default SentryTestPage;
